"use strict";

exports.__esModule = true;
exports.setSurveyQuestion = exports.setQuestionTitle = exports.preLoadQuestionTypes = exports.parseSurveyQuestionsResponsesWithImageQuestions = exports.parseSurveyQuestionsResponses = exports.makeFormData = exports.handleQuestionsOrder = exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ImageAnswer = _interopRequireDefault(require("./ImageAnswer"));

var _RadioButtonQuestion = _interopRequireDefault(require("./RadioButtonQuestion"));

var _TextAreaAnswer = _interopRequireDefault(require("./TextAreaAnswer"));

var _constants = require("../../utils/constants");

var _ImageSelectionBuilder = _interopRequireDefault(require("./ImageSelectionBuilder"));

var _ImageSelection = _interopRequireDefault(require("./ImageSelection"));

var _AddressChecker = _interopRequireDefault(require("./AddressChecker"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var preLoadQuestionTypes = [{
  id: _constants.QUESTION_TYPE_TEXTAREA,
  Name: 'Text Area',
  Placeholder: 'Enter text here'
}, {
  id: _constants.QUESTION_TYPE_IMAGE,
  Name: 'Image Capture'
}, {
  id: _constants.QUESTION_TYPE_RADIO_BUTTON,
  Name: 'Radio Button'
}, {
  id: _constants.QUESTION_TYPE_IMAGE_SELECTION,
  Name: 'Image Selection'
}];
exports.preLoadQuestionTypes = preLoadQuestionTypes;

var handleQuestionsOrder = function handleQuestionsOrder(questions) {
  return questions.sort(function (a, b) {
    return a.number - b.number;
  }).map(function (item, index) {
    item.number = index + 1;
    return item;
  });
};

exports.handleQuestionsOrder = handleQuestionsOrder;

var setQuestionTitle = function setQuestionTitle(question, title) {
  var updatedQuestion = Object.assign({}, question);
  updatedQuestion.title = title;
  return updatedQuestion;
};

exports.setQuestionTitle = setQuestionTitle;

var checkAnswerIsValid = function checkAnswerIsValid(answerLength, question, validationCallback) {
  question.isValid = answerLength > 0 || !question.isRequired;
  if (validationCallback !== null && question.isRequired) validationCallback(question);
};

var handleAddressUpdate = function handleAddressUpdate(question, address, isValid, callback) {
  question.response = address;
  question.isValid = isValid;
  callback(question);
};

var setSurveyQuestion = function setSurveyQuestion(questionId, questionType, questionNumber, isDisabled, isEditable, title, isRequired, initialOptions, updateEditedQuestionState) {
  if (title === void 0) {
    title = '';
  }

  if (isRequired === void 0) {
    isRequired = false;
  }

  if (initialOptions === void 0) {
    initialOptions = [];
  }

  if (updateEditedQuestionState === void 0) {
    updateEditedQuestionState = function updateEditedQuestionState() {};
  }

  var question = {
    questionId: questionId,
    initialOptions: initialOptions,
    number: questionNumber,
    title: title,
    questionType: questionType,
    response: '',
    answerComponent: null,
    isRequired: isRequired,
    isValid: null
  };
  var isRequiredCheck = isDisabled ? false : isRequired;
  var questionNumberString = questionNumber.toString();

  switch (questionType) {
    case _constants.QUESTION_TYPE_TEXTAREA:
      question.answerComponent = /*#__PURE__*/_react.default.createElement(_TextAreaAnswer.default, {
        disabled: isDisabled,
        placeholder: "Please enter your answer here",
        id: questionNumberString,
        name: questionNumberString,
        onChange: function onChange(e) {
          question.response = e.target.value;
          checkAnswerIsValid(question.response.length, question, updateEditedQuestionState);
        },
        isRequired: isRequiredCheck
      });
      break;

    case _constants.QUESTION_TYPE_IMAGE:
      question.answerComponent = /*#__PURE__*/_react.default.createElement(_ImageAnswer.default, {
        disabled: isDisabled,
        id: questionNumberString,
        name: questionNumberString,
        onSubmit: function onSubmit(files) {
          var file = files[0];
          question.response = file;
          checkAnswerIsValid(file.size, question, updateEditedQuestionState);
        },
        isRequired: isRequiredCheck
      });
      break;

    case _constants.QUESTION_TYPE_RADIO_BUTTON:
      question.answerComponent = /*#__PURE__*/_react.default.createElement(_RadioButtonQuestion.default, {
        disabled: isDisabled,
        editable: isEditable,
        id: questionNumberString,
        name: questionNumberString,
        initialOptions: question.initialOptions,
        onRadioButtonOptionUpdated: function onRadioButtonOptionUpdated(options) {
          question.options = options;
          updateEditedQuestionState(question);
        },
        onClick: function onClick(e) {
          question.response = e;
          checkAnswerIsValid(question.response.length, question, updateEditedQuestionState);
        },
        isRequired: isRequiredCheck
      });
      break;

    case _constants.QUESTION_TYPE_IMAGE_SELECTION:
      question.answerComponent = isEditable ? /*#__PURE__*/_react.default.createElement(_ImageSelectionBuilder.default, {
        disabled: isDisabled,
        editable: isEditable,
        id: questionNumberString,
        name: questionNumberString,
        initialOptions: question.initialOptions,
        onImageSelectionOptionUpdated: function onImageSelectionOptionUpdated(options) {
          question.options = options;
          updateEditedQuestionState(question);
        }
      }) : /*#__PURE__*/_react.default.createElement(_ImageSelection.default, {
        onImageSelected: function onImageSelected(images) {
          question.response = images;
          checkAnswerIsValid(question.response.length, question, updateEditedQuestionState);
        },
        questionId: questionNumberString,
        disabled: isDisabled,
        options: question.initialOptions,
        isRequired: isRequiredCheck
      });
      break;

    case _constants.QUESTION_TYPE_ADDRESS_CHECKER:
      question.answerComponent = /*#__PURE__*/_react.default.createElement(_AddressChecker.default, {
        onChange: handleAddressUpdate,
        question: question,
        questionId: questionNumberString,
        callback: updateEditedQuestionState
      });
      break;

    default:
      question.answerComponent = /*#__PURE__*/_react.default.createElement(_TextAreaAnswer.default, {
        disabled: isDisabled,
        placeholder: "Please enter your answer here",
        id: questionNumberString,
        name: questionNumberString,
        onChange: function onChange(e) {
          question.response = e.target.value;
          checkAnswerIsValid(question.response.length, question, updateEditedQuestionState);
        },
        isRequired: isRequiredCheck
      });
  }

  return question;
};

exports.setSurveyQuestion = setSurveyQuestion;

var parseSurveyQuestionsResponses = function parseSurveyQuestionsResponses(questions) {
  return questions.map(function (question) {
    return {
      questionId: question.questionId,
      title: question.title,
      number: question.number,
      response: question.response
    };
  });
};

exports.parseSurveyQuestionsResponses = parseSurveyQuestionsResponses;

var findQuestionResponse = function findQuestionResponse(question, imageResponses) {
  var imageResponse = imageResponses.find(function (response) {
    return response.questionId === question.questionId;
  });
  return imageResponse === undefined ? '' : imageResponse.response;
};

var parseSurveyQuestionsResponsesWithImageQuestions = function parseSurveyQuestionsResponsesWithImageQuestions(questions, imgResp) {
  return questions.map(function (question) {
    return {
      questionId: question.questionId,
      number: question.number,
      title: question.title,
      response: findQuestionResponse(question, imgResp)
    };
  });
};

exports.parseSurveyQuestionsResponsesWithImageQuestions = parseSurveyQuestionsResponsesWithImageQuestions;

var appendFiles = function appendFiles(formData, files, storeCode) {
  for (var i = 0; i < files.length; i += 1) {
    var file = files[i];
    formData.append(file.questionId + "_" + file.number + "_" + storeCode, file.response);
  }

  return formData;
};

var makeFormData = function makeFormData(files, storeCode) {
  var formData = new FormData();
  formData = appendFiles(formData, files, storeCode);
  return formData;
};

exports.makeFormData = makeFormData;
var _default = setSurveyQuestion;
exports.default = _default;